import { useEffect, useRef, useState } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Avatar, Button, Divider, Modal, Space, Table, Typography } from "antd";
import "./representation-modal.scss";
import { UserInfo } from "@/entities/project";
import { RepresentationFormAdd } from "../representation-form-add";
import { RepresentationFormAuthor } from "../representation-form-author";
import { RepresentationFormEmail } from "../representation-form-email";

const { Text } = Typography;

interface IRepresentationModal {
  isOpen: boolean;
  handleClose: () => void;
  handleAdd: (id?: string, userInfo?: UserInfo) => void;
  title?: string;
  type?: "settings" | "author";
  isLoading?: boolean;
  error?: string;
  projectParticipantId?: any;
}

export const RepresentationModal = ({
  isOpen,
  handleClose,
  handleAdd,
  title = "Добавление Уполномоченного",
  type,
  isLoading,
  error,
  projectParticipantId,
}: IRepresentationModal) => {
  const [isShowFormAdd, setIsShowFormAdd] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [clearTrigger, setClearTrigger] = useState(0);
  const prevIsOpen = useRef(isOpen);

  useEffect(() => {
    if (!isOpen && prevIsOpen.current) {
      setUserInfo(null);
      setIsShowFormAdd(false);
      setClearTrigger((prev) => prev + 1);
    }
    prevIsOpen.current = isOpen;
  }, [isOpen]);

  const handleIsShowFalse = () => {
    setIsShowFormAdd(false);
    setUserInfo(null);
  };
  const handleOnCancel = () => {
    handleClose();
  };
  const handleLocalAdd = () => {
    if (userInfo) {
      handleAdd(userInfo.userId, userInfo);
    }
  };

  const onSuccess = (user: UserInfo) => {
    setUserInfo(user);
  };

  const data = userInfo
    ? [
        {
          key: userInfo.userId,
          name:
            [
              userInfo.userSurname,
              userInfo.userFirstName,
              userInfo.userMiddleName,
            ]
              .filter(Boolean)
              .join(" ") || "Нет данных",
          organization:
            userInfo.userCompanies?.length > 0
              ? userInfo.userCompanies
                  .map((company) => company.shortName)
                  .join(", ")
              : "Нет данных",
          position:
            userInfo.userCompanies?.length > 0
              ? userInfo.userCompanies[0].position
              : "Нет данных",
          initials:
            [userInfo.userSurname?.[0], userInfo.userFirstName?.[0]]
              .filter(Boolean)
              .join("")
              .toUpperCase() || "Нет данных",
          email: userInfo.userEmail || "Нет данных",
          phone: userInfo.userMobilePhone || "Нет данных",
          role: "Нет данных",
          nostroyId: "Нет данных",
        },
      ]
    : [];

  const columns = [
    {
      title: "ФИО",
      dataIndex: "name",
      key: "name",
      render: (name: string, record: any) => (
        <Space size="middle">
          <Avatar>{record.initials}</Avatar>
          <Text>{name}</Text>
        </Space>
      ),
    },
    {
      title: "Организация",
      dataIndex: "organization",
      key: "organization",
      render: (organization: string) => <Text>{organization}</Text>,
    },
    {
      title: "Должность",
      dataIndex: "position",
      key: "position",
      render: (position: string) => <Text>{position}</Text>,
    },
    {
      key: "action",
      render: () => (
        <Button
          type="text"
          icon={
            <CloseCircleOutlined style={{ color: "red", fontSize: "16px" }} />
          }
          danger
          style={{ padding: 0 }}
          onClick={handleIsShowFalse}
        />
      ),
    },
  ];

  return (
    <>
      <Modal
        open={isOpen}
        onCancel={handleOnCancel}
        footer={null}
        destroyOnClose
        centered
        width={700}
        title={title}
      >
        <div className="representation-modal-description">
          Поиск осуществляется по адресу электронной почты пользователя, который
          является сотрудником одной из организаций-участников проекта
        </div>

        <RepresentationFormEmail
          onSuccess={onSuccess}
          error={error}
          projectParticipantId={projectParticipantId}
          clearTrigger={clearTrigger}
        />

        {userInfo ? (
          <div className="rep-author-modal">
            <Table
              dataSource={data}
              columns={columns}
              pagination={false}
              showHeader
              bordered={false}
              style={{ width: "100%" }}
            />
          </div>
        ) : null}

        {isShowFormAdd && type !== "settings" ? (
          <RepresentationFormAdd />
        ) : null}

        {type === "author" ? <RepresentationFormAuthor /> : null}

        <Divider />
        <Button
          type="primary"
          disabled={!userInfo}
          loading={isLoading}
          onClick={handleLocalAdd}
        >
          Добавить
        </Button>
      </Modal>
    </>
  );
};
